import { useReactiveVar } from '@apollo/client';
import 'dayjs/locale/de';
import Loader from './components/common/Loader/Loader';
import { useCurrentUser } from './hooks/useCurrentUser';
import { Navigator } from './routes';
import { authState } from './vars/auth';

function App() {
  const { loading } = useReactiveVar(authState);
  useCurrentUser();

  if (loading) {
    return <Loader />;
  }
  return <Navigator />;
}

export default App;
